/**
 * Created by Christof Sander on 27.01.2017.
 */

module.exports = {
	config: {
		scroll: {                           // scroll transition params
			duration:   0.3,                // float - nr of seconds duration for a scroll operation
			ease:       Cubic.easeInOut     // TweenMax-Easing-Function - how to ease the scrolling
		},
		bump: {
			duration:   0.3,                // float - nr of seconds duration for a bump-in and -out operation
			hold:   	0.010,              // float - nr of seconds to hold on bump-position
			distance:   60,                	// integer - nr of pixels to bump
			ease:       Cubic.easeInOut     // TweenMax-Easing-Function - how to ease the scrolling
		},
		swipeMinDistance: 0.08
	},
	model: {
		draggablesInitialized: false,
		dragBlocked: false,
		properties: {
			initialized: false,
			nrOfActiveWindows: 0,
			realWindows: [],
			windows: [],
			windowUpdates: 0,
			windowRefreshNecessary: false,
			columnMenu: {},
			activeWindowIndex: -1,
			wrapperY: 0,
			scrollInCharge: {},
			slider: {
				delta: 0,
				height: 0
			},
			routeID: 0,
			route: '',
			anchor: '',

			active: true,
			previous: false,
			actual: true,
			next: false
		},
		breadCrumbs: []
	},

	events: {
		preventOverScrollErrors: {
			type: 'touchmove',
			action: function(event){
				// prevent native scroll bounces on apple devices
				if(!(((event.data.component.model || {}).gridNavigator || {}).model || {}).endlessScrollInEffect){
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			}
		}
	},

	methods: {

		/**
		 * this function will be called when the grid has been updated by the grid-navigator.
		 *
		 * @param   gridDimensions      {} - actual gridDimensions
		 */
		onGridUpdate: function(gridDimensions){

			// recalculate slider parameters
			this.model.properties.gridDimensions = gridDimensions;
			this.model.properties.slider.height = Math.round(this.model.properties.gridDimensions.height / Math.min(5, this.model.properties.nrOfActiveWindows));
			this.model.properties.slider.delta  = Math.round((this.model.properties.gridDimensions.height - this.model.properties.slider.height) / (this.model.properties.nrOfActiveWindows - 1));
			if(this.model.sliderDraggable){
				this.model.sliderDraggable.applyBounds({
					minY: 0,
					maxY: this.model.properties.gridDimensions.height - this.model.properties.slider.height
				});
			}

			// set new sliders' height
			TweenMax.set(
				this.model.$slider,
				{
					height: this.model.properties.slider.height
				}
			);
		},

		/**
		 * this function is used to set the columns state in preparation of a transition
		 *
		 * @param   position                        string - previous | actual | next | empty
		 *                                          NOTE: if the position is not given or empty the column will be hidden
		 * @param   transitionType                  string - opacity | slide
		 * @param   environmentColumnFallback       Component - this component is one which already has been initialized
		 *                                          NOTE:   this is necessary to access the precalculated environment dependent values
		 *                                                  on initial setState call of a dynamic loaded component.
		 */
		setState: function(position, transitionType, environmentColumnFallback){
			this.model.properties.active    = false;
			this.model.properties.previous  = false;
			this.model.properties.actual    = false;
			this.model.properties.next      = false;
			this.$.removeClass('active previous actual next');
			var x;
			var clazz = 'active ' + position;
			var opacity = 1;

			switch(position){
				case 'previous':
					this.model.properties.active = true;
					this.model.properties.previous = true;
					if(transitionType === 'opacity'){
						x = 0;
					}
					else if(transitionType === 'slide') {
						x = 0;
					}
					break;

				case 'actual':
					this.model.properties.active = true;
					this.model.properties.actual = true;
					x = 0;
					break;

				case 'next':
					this.model.properties.active = true;
					this.model.properties.next = true;
					if(transitionType === 'opacity'){
						x = 0;
						opacity = 0;
					}
					else if(transitionType === 'slide') {
						x = (this.model.properties.gridDimensions.width || environmentColumnFallback.model.properties.gridDimensions.width);
					}
					break;

				default:
					clazz = undefined;
					break;
			}

			if(x !== undefined){
				TweenMax.set(
					this.$,
					{
						x:          x,
						opacity:    opacity
					}
				);
			}

			if(clazz !== undefined) {
				this.$.addClass(clazz);
			}
		},

		/**
		 * this function returns the properties of a window identified by the given routeComponentID or anchor.
		 *
		 * @param   routeComponentID        int - routeComponentID of the wanted window
		 * @param   anchor                  string - anchor of the wanted window (the first one matching the anchor will be taken)
		 * @param   windowIndex             int - windowIndex of the wanted window
		 * @return  {} - windowProperties
		 */
		getWindowProperties: function(routeComponentID, anchor, windowIndex){
			if(windowIndex === undefined){

				if(anchor){
					for(var subMenuName in (this.model.properties.columnMenu.menu || [])){
						if(this.anchorToUrl(subMenuName) == anchor){
							routeComponentID = this.model.properties.columnMenu.menu[subMenuName];
							break;
						}
					}
				}

				if(routeComponentID){
					for(windowIndex in this.model.properties.windows){
						if(this.model.properties.windows[windowIndex].routeComponentID == routeComponentID){
							break;
						}
					}
					windowIndex = parseInt(windowIndex);
				}
				else if(this.model.properties.activeWindowIndex >= 0){
					windowIndex = this.model.properties.activeWindowIndex;
				}
				else if(this.model.properties.windows.length > 0) {
					windowIndex = 0;
				}
				else {
					windowIndex = this.model.properties.activeWindowIndex;
				}
			}

			if(windowIndex >= 0 && this.model.properties.windows[windowIndex]){

				// estimate routeComponentID if necessary
				if(!routeComponentID){
					routeComponentID = this.model.properties.windows[windowIndex].routeComponentID;
				}

				// estimate used anchor if necessary
				var usedAnchor;
				if(routeComponentID && this.model.properties.columnMenu && this.model.properties.columnMenu.windowList && this.model.properties.columnMenu.windowList[routeComponentID]){
					usedAnchor = this.anchorToUrl(this.model.properties.columnMenu.windowList[routeComponentID]);
				}

				return {
					prevIndex:              (windowIndex > 0 ? (windowIndex - 1) : false),
					index:                  windowIndex,
					nextIndex:              (windowIndex < (this.model.properties.windows.length - 1) ? windowIndex + 1 : false),
					windowComponentIndex:   this.model.properties.windows[windowIndex].componentIndex,
					windowRouteComponentID: routeComponentID,
					windowRoutePath:        this.model.properties.windows[windowIndex]._routePath,
					usedAnchor:             usedAnchor,
					active:                 this.model.properties.windows[windowIndex].model.active
				};
			}

			return false;
		},

		/**
		 * this function returns the routeComponentID of the next window.
		 *
		 * @param   windowIndex     int - wanted windowIndex
		 * @return  int - -1 in an error case
		 */
		getWindowRouteComponentID: function(windowIndex){
			if(
				windowIndex != undefined &&
				this.model.properties.windows[windowIndex] &&
				this.model.properties.windows[windowIndex].routeComponentID){
				return this.model.properties.windows[windowIndex].routeComponentID;
			}
			return -1;
		},

		/**
		 * this function is used to prepare an anchor for an url.
		 *
		 * @param   anchor      string - anchor to prepare
		 * @return  string - prepared anchor
		 */
		anchorToUrl: function(anchor){
			return (anchor || '').toLowerCase().replace(this.model.anchorRegex, '-');
		},

		/**
		 * this function is used to get a clean human readable anchor.
		 *
		 * @param   anchor      string - anchor to prepare
		 * @return  string - clean anchor
		 */
		getCleanAnchor: function(anchor){
			return (anchor || '').replace(this.model.anchorRegex, ' ');
		},

		/**
		 * this function is used to bump the colum up to show the user that there is no more window in the wanted direction.
		 *
		 * @param 	upwards 		boolean - should an upwards or downwards bump be performed
		 */
		bump: function(upwards){
			if(!this.model.properties || (this.model.properties.nrOfActiveWindows || 0) < 2) return;

			var self = this;
			var wrapperYStart, wrapperYEnd;
			if(!!upwards){
				wrapperYStart 	= self.config.bump.distance;
				wrapperYEnd 	= 0;
			}
			else {
				wrapperYStart 	= self.model.properties.wrapperY - self.config.bump.distance;
				wrapperYEnd 	= self.model.properties.wrapperY;
			}

			// bump up window animation
			TweenMax.to(
				self.model.$windowWrapper,
				self.config.bump.duration,
				{
					ease:   self.config.bump.ease,
					y:      wrapperYStart,
					onComplete: function(){
						window.setTimeout(function(self){
							TweenMax.to(
								self.model.$windowWrapper,
								self.config.bump.duration,
								{
									ease:   self.config.bump.ease,
									y:      wrapperYEnd
								}
							);
						}, self.config.bump.hold * 1000, self);
					}
				}
			);
		},

		/**
		 * this function is used to scroll the column to the wanted window.
		 *
		 * @param toWindowIndex     int - which window should be visible
		 * @param triedAnchor       string - the anchor used to scroll to this window
		 * @param windowProperties  {} - windowProperties of the targetWindow
		 * @param routeChanged      boolean - has the route (not the anchor) been changed
		 * @param initialMove       boolean - is this a initial move operation? (only true for the first column)
		 * @param styleChanged      boolean - has the environment.style been changed?
		 * @param dragInCharge      boolean - will the windowWrapper or slider actually be dragged?
		 * @param refresh           boolean - should the scroll position refreshed even if the window position is right?
		 */
		scrollTo: function(toWindowIndex, triedAnchor, windowProperties, routeChanged, initialMove, styleChanged, dragInCharge, refresh){
			// init
			var self = this;
			toWindowIndex 	= parseInt(toWindowIndex);
			var up      	= this.model.properties.activeWindowIndex > toWindowIndex;
			var down    	= this.model.properties.activeWindowIndex < toWindowIndex;
			var force   	= !windowProperties.active || styleChanged || dragInCharge || refresh;

			// is a scroll animation necessary?
			if(force || (down && !self.model.properties.scrollInCharge.down) || (up && !self.model.properties.scrollInCharge.up) || (self.model.gridNavigator.model.endlessScrollInEffect && triedAnchor)){

				if(self.model.gridNavigator.model.endlessScrollInEffect){
					var refreshHead = false;

					if(triedAnchor) {
						var $anchorContainer = self.model.$windowWrapper.find('section.windows');
						var $anchorElement = $anchorContainer.find('#' + triedAnchor);
						if($anchorContainer.length > 0 && $anchorElement.length > 0){
							// scroll window animation
							$anchorContainer.scrollTop(
								$anchorElement.offset().top -
								$anchorContainer.offset().top +
								$anchorContainer.scrollTop()
							);
							refreshHead = true;
							self.model.gridNavigator.refreshHead(self, windowProperties, true, initialMove);
						}
					}
					if(refresh){
						refreshHead = true;
					}

					if(refreshHead){
						// refresh head-panel according to the new active window
						self.model.gridNavigator.refreshHead(self, windowProperties, true, initialMove);
					}

				} else {

					// prepare
					var toWindowRouteComponentID, newAnchor, i;
					var gridDimensions      = this.model.properties.gridDimensions;
					var sliderDimensions    = this.model.properties.slider;
					windowProperties.triedAnchor = triedAnchor;

					// respect invisible windows for scroll calculations
					var scrollToWindowIndex     = toWindowIndex + this.model.properties.windows[toWindowIndex].model.windowIndexOffset;
					//var activeScrollWindowIndex = this.model.properties.activeWindowIndex + this.model.properties.windows[this.model.properties.activeWindowIndex].model.windowIndexOffset;

					var activeScrollWindowIndex = this.model.properties.activeWindowIndex;
					if (this.model.properties.windows[this.model.properties.activeWindowIndex]) {
						activeScrollWindowIndex += this.model.properties.windows[this.model.properties.activeWindowIndex].model.windowIndexOffset;
					}
					if (activeScrollWindowIndex<0) activeScrollWindowIndex=0;

					// get the right window when the actual target is not visible at the moment
					if(!this.model.properties.windows[toWindowIndex].model.active){
						if(down || force){
							// look for next available window
							for(i = toWindowIndex + 1; i < this.model.properties.windows.length; i++){
								if(this.model.properties.windows[i].model.active){
									toWindowIndex = i;
									scrollToWindowIndex = i + this.model.properties.windows[i].model.windowIndexOffset;
									if(scrollToWindowIndex != activeScrollWindowIndex){
										break;
									}
								}
							}
						}
						if(up || (force && scrollToWindowIndex == activeScrollWindowIndex)){
							// look for next available window
							for(i = toWindowIndex - 1; i >= 0; i--){
								if(this.model.properties.windows[i].model.active){
									toWindowIndex = i;
									scrollToWindowIndex = i + this.model.properties.windows[i].model.windowIndexOffset;
									if(down || scrollToWindowIndex != activeScrollWindowIndex){
										break;
									}
								}
							}
						}
					}

					// has a valid scrollToWindowIndex been found
					if(scrollToWindowIndex > -1){
						// check if there is an active window to scroll to
						if(force || scrollToWindowIndex != activeScrollWindowIndex){

							if(up)          self.model.properties.scrollInCharge.up = true;
							else if(down)   self.model.properties.scrollInCharge.down = true;

							this.model.properties.wrapperY = -(self.model.properties.windowScrollParts[toWindowIndex] * gridDimensions.height);

							// set new anchor if necessary
							toWindowRouteComponentID = this.model.properties.windows[toWindowIndex].routeComponentID;
							if(
								toWindowRouteComponentID &&
								self.model.properties.columnMenu.windowList &&
								self.model.properties.columnMenu.windowList[toWindowRouteComponentID] &&
								triedAnchor != (newAnchor = this.anchorToUrl(self.model.properties.columnMenu.windowList[toWindowRouteComponentID]))
							){
								windowProperties.usedAnchor = newAnchor;
							}

							// NOTE: if the actual wanted windowIndex is not available (not visible) get the right target-window-properties
							this.model.properties.activeWindowIndex = toWindowIndex;
							var toWindowProperties = self.getWindowProperties();
							toWindowProperties.triedAnchor = triedAnchor;
							toWindowProperties.usedAnchor = newAnchor;

							// refresh head-panel according to the new active window
							self.model.gridNavigator.refreshHead(self, toWindowProperties, true, initialMove);

							// mark actual window
							self.$.find('.templates_window_window').removeClass('actual');
							getComponent(toWindowProperties.windowComponentIndex).$.addClass('actual');

							// calculate slider position
							this.model.properties.sliderY = scrollToWindowIndex * sliderDimensions.delta;
							if(scrollToWindowIndex == (this.model.properties.nrOfActiveWindows - 1)) this.model.properties.sliderY = gridDimensions.height - sliderDimensions.height;

							// if this is the actual column (not an invisible one) animate new window- and slider-position
							if(this.model.properties.actual){
								// scroll window animation
								TweenMax.to(
									this.model.$windowWrapper,
									this.config.scroll.duration,
									{
										ease:   this.config.scroll.ease,
										y:      this.model.properties.wrapperY,
										onComplete: function(){
											self.model.properties.scrollInCharge.up = false;
											self.model.properties.scrollInCharge.down = false;
										},
										onOverwrite: function(){
											self.model.properties.scrollInCharge.up = false;
											self.model.properties.scrollInCharge.down = false;
										}
									}
								);

								// scroll slider animation if necessary
								TweenMax.to(
									this.model.$slider,
									this.config.scroll.duration,
									{
										ease:   self.config.scroll.ease,
										y:      this.model.properties.sliderY
									}
								);
								self.notifyChildrenAboutScroll();
							}
							// if this is an invisible column set new window- and slider-position
							else {
								// set window position
								TweenMax.set(
									this.model.$windowWrapper,
									{
										y:      this.model.properties.wrapperY
									}
								);
								self.model.properties.scrollInCharge.up = false;
								self.model.properties.scrollInCharge.down = false;

								// set slider position
								TweenMax.set(
									this.model.$slider,
									{
										y:      this.model.properties.sliderY
									}
								);
							}
						}
						// bump down if index is higher than the nr of available windows
						else {
							self.bump(false);
							self.notifyChildrenAboutScroll();
						}
					}
					// update head and anchor even if the window- and slider-position can be kept
					else if(force) {
						// set new anchor if necessary
						toWindowRouteComponentID = (
							this.model.properties.windows[this.model.properties.activeWindowIndex] ?
								this.model.properties.windows[this.model.properties.activeWindowIndex].routeComponentID
								:
								false
						);
						if(
							toWindowRouteComponentID &&
							self.model.properties.columnMenu.windowList &&
							self.model.properties.columnMenu.windowList[toWindowRouteComponentID] &&
							triedAnchor != (newAnchor = this.anchorToUrl(self.model.properties.columnMenu.windowList[toWindowRouteComponentID]))
						){
							windowProperties.usedAnchor = newAnchor;
							self.model.gridNavigator.refreshHead(self, windowProperties);
						}
					}
					// bump up if index is lower than zero
					else {
						self.bump(true);
						self.notifyChildrenAboutScroll();
					}
				}
			}
			// refresh head-panel if necessary
			else if(routeChanged || initialMove) {
				self.model.gridNavigator.refreshHead(self, windowProperties, initialMove, initialMove);
			}
		},

		/**
		 * this function notifies all children of the actual column which wants to know about the scrollTo function-call.
		 */
		notifyChildrenAboutScroll: function(){
			this.triggerFind('onScroll');
		},

		/**
		 * this function will be called by the environmental refresh of a window and is used
		 * to pre-calculate some essential values.
		 *
		 * @param refreshWindowList        boolean - has something changed which needs to refresh the whole window list?
		 */
		onWindowUpdate: function(refreshWindowList){
			this.model.properties.windowRefreshNecessary |= refreshWindowList;
			this.model.properties.windowUpdates++;
			// only the last window will be taken to pre-calculate the essential values
			if(this.model.properties.windowUpdates < this.model.properties.realWindows.length) return;
			this.model.properties.windowUpdates = 0;

			if(this.model.properties.windowRefreshNecessary){
				this.model.properties.windowRefreshNecessary = false;

				var self = this;
				self.model.properties.windows = [];
				self.model.properties.windowScrollParts = [];
				self.model.properties.nrOfActiveWindows = 0;
				self.model.properties.nrOfInActiveWindows = 0;
				var lastActiveWindowIndexBeforeActualWindow = -1;
				var firstActiveWindowIndexAfterActualWindow = -1;
				var active, activeWindowIsActive;
				var subMenuName;
				self.model.properties.columnMenu.nrOfActiveMenuElements = 0;
				for(subMenuName in self.model.properties.columnMenu.nrOfActiveWindows){
					self.model.properties.columnMenu.nrOfActiveWindows[subMenuName] = 0;
				}
				subMenuName = undefined;
				var windowIndex, dynamicProperties;
				var windowIndexOffset = 0;
				var windowScrollPart = 0;
				for(var realWindowIndex in self.model.properties.realWindows){
					realWindowIndex = parseInt(realWindowIndex);
					windowIndex = realWindowIndex + windowIndexOffset;
					active = self.model.properties.realWindows[realWindowIndex].model.active;

					if(windowIndex < self.model.properties.activeWindowIndex){
						if(active){
							lastActiveWindowIndexBeforeActualWindow = parseInt(windowIndex);
						}
					}
					else if(windowIndex > self.model.properties.activeWindowIndex){
						if(firstActiveWindowIndexAfterActualWindow < 0 && active){
							firstActiveWindowIndexAfterActualWindow = parseInt(windowIndex);
						}
					}
					else {
						activeWindowIsActive = active;
					}

					if(self.model.properties.realWindows[realWindowIndex].model.subMenuName){
						subMenuName = self.getCleanAnchor(self.model.properties.realWindows[realWindowIndex].model.subMenuName);
					}

					if(active){
						self.model.properties.nrOfActiveWindows++;
						if(subMenuName){
							self.model.properties.columnMenu.nrOfActiveWindows[subMenuName]++;
							self.model.properties.columnMenu.nrOfActiveMenuElements++;
						}
					}
					else {
						self.model.properties.nrOfInActiveWindows++;
					}
					self.model.properties.realWindows[realWindowIndex].model.windowIndexOffset = -self.model.properties.nrOfInActiveWindows;
					self.model.properties.windows[windowIndex] = self.model.properties.realWindows[realWindowIndex];
					self.model.properties.windowScrollParts[windowIndex] = windowScrollPart;

					if(active){
						if(self.model.properties.realWindows[realWindowIndex].model.isDynamic && (dynamicProperties = self.model.properties.realWindows[realWindowIndex].model.dynamicProperties) && dynamicProperties.nrOfDynamicWindows > 1){
							var nrOfAdditionalWindows = 0;
							if(dynamicProperties.scrollStep == 'full') {
								nrOfAdditionalWindows = dynamicProperties.nrOfDynamicWindows - 1;
							}
							else if(dynamicProperties.scrollStep == 'half') {
								nrOfAdditionalWindows = dynamicProperties.nrOfDynamicRows - 2;
							}

							if(nrOfAdditionalWindows > 0){
								for(var d = 0; d < nrOfAdditionalWindows; d++){
									windowIndex++;
									windowIndexOffset++;
									if(dynamicProperties.scrollStep == 'half')  windowScrollPart += 0.5;
									else                                        windowScrollPart += 1;
									self.model.properties.nrOfActiveWindows++;
									self.model.properties.windows[windowIndex] = self.model.properties.realWindows[realWindowIndex];
									self.model.properties.windowScrollParts[windowIndex] = windowScrollPart;
								}
							}
						}
						
						windowScrollPart++;
					}
				}

				if(!activeWindowIsActive){
					if(firstActiveWindowIndexAfterActualWindow > -1)        self.model.properties.activeWindowIndex = firstActiveWindowIndexAfterActualWindow;
					else if(lastActiveWindowIndexBeforeActualWindow > -1)   self.model.properties.activeWindowIndex = lastActiveWindowIndexBeforeActualWindow;
					else                                                    console.error('no active window found');
				}

				// set slider visible or invisible
				if(self.model.properties.nrOfActiveWindows > 1){
					self.model.$slider.show();
				}
				else {
					self.model.$slider.hide();
				}
			}

			// init draggables if necessary
			if(!this.model.draggablesInitialized && self && (self.model.properties.windows || []).length > 1){
				this.initDraggables();
			}

			// tell column that all windows are ready
			this.model.gridNavigator.onColumnUpdate();
		},

		/**
		 * this function returns the human readable variant of a windowIndex - without index offset of inactive windows and starting with 1
		 * NOTE: if no windowIndex is given the active window index will be taken instead.
		 *
		 * @param   windowIndex     int - window index
		 * @return  int - human readable window index
		 */
		getHumanReadableWindowIndex: function(windowIndex){
			if(windowIndex == undefined) windowIndex = this.model.properties.activeWindowIndex;
			if(this.model.properties.windows[windowIndex]) return windowIndex + (this.model.properties.windows[windowIndex].model.windowIndexOffset || 0) + 1;
			return 0;
		},

		/**
		 * update breadCrumbs in breadCrumbComponent
		 * @param {[]} breadCrumbs
		 */
		updateBreadCrumbs: function(breadCrumbs){
			this.find('templates_headPanel_breadCrumbs', function(breadCrumbComponent){
				breadCrumbComponent.model.breadCrumbs = breadCrumbs || [];
				breadCrumbComponent.refresh();
			});
		},

		/**
		 * this function blocks the column draggable
		 */
		blockDrag: function(){
			this.model.dragBlocked = true;
		},
		/**
		 * this function frees the column draggable
		 */
		freeDrag: function(){
			this.model.dragBlocked = false;
		},


		///////////////////////////////////////////
		///// DRAGGABLE HANDLING
		///////////////////////////////////////////

		onSliderDragStart: function (component) {
			if(component.model.dragBlocked){
				this.endDrag();
				return;
			}
			component.model.$sliderWrapper.addClass('active');
		},
		onSliderDrag: function (component) {
			var nextWindowIndex, wrapperY;
			if(
				(nextWindowIndex = Math.round(this.y / component.model.properties.slider.delta)) > -1 &&
				nextWindowIndex < component.model.properties.windowScrollParts.length &&
				(wrapperY = -parseInt(component.model.properties.windowScrollParts[nextWindowIndex] * component.model.properties.gridDimensions.height)) < 1
			){
				TweenMax.to(
					component.model.$windowWrapper,
					component.config.scroll.duration,
					{
						ease:   component.config.scroll.ease,
						y:      wrapperY
					}
				);
			}
		},
		onSliderDragEnd: function (component) {
			if(component.model.dragBlocked) return;
			component.model.$sliderWrapper.removeClass('active');

			var nextWindowIndex;
			if(
				(nextWindowIndex = Math.round(this.y / component.model.properties.slider.delta)) > -1 &&
				nextWindowIndex < component.model.properties.windowScrollParts.length
			){
				component.model.gridNavigator.to(undefined, undefined, undefined, nextWindowIndex, false, true);
			}
		},
		onWindowDragStart: function (component) {
			if(component.model.dragBlocked || component.model.gridNavigator.model.endlessScrollInEffect) this.endDrag();
		},
		onWindowDragEnd: function (component) {
			if(component.model.dragBlocked || component.model.gridNavigator.model.endlessScrollInEffect) return;

			// init
			var dynamicProperties, deltaY;
			var nextWindowIndex         = component.model.properties.activeWindowIndex;
			var usedSwipeMinDistance    = component.config.swipeMinDistance;
			var scrollToNextWindow      = false;

			// take min swipe distance according to actual window
			if ((dynamicProperties = component.model.properties.windows[nextWindowIndex].model.dynamicProperties) && dynamicProperties.scrollStep === 'half') {
				usedSwipeMinDistance /= 2;
			}

			// upwards
			if((deltaY = (this.startY - this.y)) < 0){
				scrollToNextWindow = (--nextWindowIndex >= 0);
			}
			// downwards
			else if(deltaY > 0) {
				scrollToNextWindow = (++nextWindowIndex < component.model.properties.windowScrollParts.length);
			}

			// min swipe distance reached?
			if(scrollToNextWindow) {
				if(Math.abs(deltaY / component.model.properties.gridDimensions.height) < usedSwipeMinDistance){
					scrollToNextWindow = false;
				}
			}

			// scroll to actual or next window
			component.model.gridNavigator.to(undefined, undefined, undefined, (scrollToNextWindow ? nextWindowIndex : undefined), false, true);

			// when window drag has been started manually the component which has started the drag mode has to know that.
			if(typeof(component.model.windowDraggableStartCallback) == 'function'){
				component.model.windowDraggableStartCallback();
				delete component.model.windowDraggableStartCallback;
			}
		},
		/**
		 * this function is used to start the drag mode of the window manually by giving the original pointer-event.
		 * when the drag has ended the given callback function will be called.
		 *
		 * @param event         Event - original pointer event
		 * @param callback      function - optional - callback function which will be called after dragEnd
		 */
		startWindowDrag: function(event, callback){
			if(this.model.windowDraggable){
				this.model.windowDraggableStartCallback = callback;
				this.model.windowDraggable.startDrag(event);
			}
			else if(typeof(callback) == 'function'){
				callback();
			}
		},

		/**
		 * this function is used to initialize the draggables
		 */
		initDraggables: function(){
			var self = this;

			self.model.draggablesInitialized = true;
			self.model.sliderDraggable = Draggable.create(
				self.model.$slider,
				{
					type: "y",
					edgeResistance: 0.85,
					lockAxis: true,
					cursor: 'auto',

					onDragStart:        self.onSliderDragStart,
					onDragStartParams:  [self],
					onDrag:             self.onSliderDrag,
					onDragParams:       [self],
					onDragEnd:          self.onSliderDragEnd,
					onDragEndParams:    [self]
				}
			)[0];

			self.model.windowDraggable = Draggable.create(
				self.model.$windowWrapper,
				{
					type: "y",
					edgeResistance: 0.85,
					lockAxis: true,
					cursor: 'auto',

					onDragStart:        self.onWindowDragStart,
					onDragStartParams:  [self],
					onDragEnd:          self.onWindowDragEnd,
					onDragEndParams:    [self]
				}
			)[0];
		},

		// prevent text select issues caused by draggables where there should not be initialized any in case of normal loading (timing)
		onAdditionalStyleUpdate: function(){
			var self = this;
			if((((self.model.gridNavigator || {}).model || {}).additionalStyles || []).indexOf('fullHeight') > -1){
				self.$.addClass('fullHeight');
			}

			if(self.model.windowDraggable){
				if(self.model.gridNavigator.model.endlessScrollInEffect){
					self.model.windowDraggable.disable();
				} else {
					self.model.windowDraggable.enable();
				}
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			self.model.anchorRegex = new RegExp('[-_\\s\\#\\?\\+~]+', 'g');
			self.model.properties.windows = [];
			self.model.properties.columnMenu = {
				windowList:             {},
				menu:                   {},
				nrOfActiveWindows:      {},
				nrOfActiveMenuElements: 0
			};
			self.model.properties.activeWindowIndex = -1;

			if(String(self.model.properties.route || '').split('/').length > 3 && ((self.model.properties.route || '').match(/^\/de\/unternehmen\/referenzen\/galerie/) === null)){
				$element.addClass('fullHeight');
			}

			var firstWindow = true;
			var firstWindowSubMenuName = '';
			var subMenuName;
			this.find('templates_window_window', function(windowComponent){
				if(windowComponent.model.subMenuName){
					subMenuName = self.getCleanAnchor(windowComponent.model.subMenuName);
				}
				if(firstWindow){
					firstWindow = false;
					if(subMenuName){
						firstWindowSubMenuName = subMenuName;
					}
				}

				if(subMenuName){
					if(!self.model.properties.columnMenu.menu[subMenuName]){
						self.model.properties.columnMenu.menu[subMenuName] = windowComponent.routeComponentID;
						self.model.properties.columnMenu.nrOfActiveWindows[subMenuName] = 0;
					}
					if(windowComponent.model.active){
						self.model.properties.columnMenu.nrOfActiveWindows[subMenuName]++;
						self.model.properties.columnMenu.nrOfActiveMenuElements++;
					}
					self.model.properties.columnMenu.windowList[windowComponent.routeComponentID] = subMenuName;
				}
				self.model.properties.realWindows.push(windowComponent);
			});
			if(self.model.properties.windows.length > 0){
				self.model.properties.activeWindowIndex = 0;
			}
			self.model.properties.nrOfActiveWindows = self.model.properties.windows.length;
			this.closest('layouts_gridNavigator_gridNavigator', function(gridComponent){
				self.model.gridNavigator = gridComponent;
			});
			self.model.properties.anchor = self.anchorToUrl(firstWindowSubMenuName);

			// init slider
			if((self.model.$sliderWrapper = self.$.find('> .sliderWrapper')) && (self.model.$slider = self.model.$sliderWrapper.find('> .slider')) && (self.model.$windowWrapper = self.$.find('> .windowWrapper'))){
				if(self.model.properties.realWindows.length > 1){
					self.model.$slider.show();

					if(!options.refresh){
						self.initDraggables();
					}
				}
				else {
					self.model.$slider.hide();
				}
			}
		}
	}
};
